module.exports = __webpack_public_path__ + "static/media/infinity.2f1cf78a.svg";